/**
 * Read a JSON body without letting an empty one take the screen down.
 *
 * `response.json()` throws on a body that isn't JSON, and the API sends
 * exactly that on a 401 — empty. Written the old way, as a direct `.json()`
 * on the awaited call, the throw landed in whatever method made it, and a
 * screen that gates
 * its render on the result then never renders. That is how an expired
 * session turned the whole admin blank.
 *
 * Status is deliberately NOT checked. The API returns `{ error: "..." }`
 * bodies alongside 4xx codes and screens read that to tell somebody what
 * went wrong, so skipping the parse on a failed response would swallow the
 * message. Anything that genuinely isn't JSON comes back as null, which is
 * what the `if (res && ...)` guards at the call sites already expect.
 */
export async function safeJson(request: Promise<Response>): Promise<any> {
	try {
		const response = await request;
		const body = await response.text();
		return body ? JSON.parse(body) : null;
	} catch {
		return null;
	}
}
